module.exports = __webpack_public_path__ + "img/certified@2x.d44be83.jpg";